import React, { useState } from "react";
import BaseModal from "components/BaseModal";
import { useSession } from "hooks/useSession";

export default function DMTTransactionStatusCheckModal({ show, onClose, userData }) {
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const { userid } = useSession();

  const [transactionType, setTransactionType] = useState(userData?.transaction_type || "");
  const [refid, setRefid] = useState(userData?.refid || "");

  const showToast = (message, type = "primary") => {
    const alertDiv = document.createElement("div");
    alertDiv.className = `alert alert-${type} alert-dismissible position-fixed top-0 end-0 m-3 shadow`;
    alertDiv.setAttribute("role", "alert");
    alertDiv.style.zIndex = 2000;
    alertDiv.innerHTML = `
      <div class="d-flex justify-content-between align-items-center">
        <p class="mb-0 flex-grow-1">${message}</p>
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
      </div>`;
    document.body.appendChild(alertDiv);
    setTimeout(() => alertDiv.remove(), 3000);
  };

  const validateForm = () => {
    const newErrors = {};
    if (!transactionType.trim()) newErrors.transaction_type = "TRANSACTION_TYPE is required.";
    if (!refid.trim()) newErrors.refid = "REFID is required.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleCheckStatus = async () => {
    if (!validateForm()) {
      showToast("Please fill in all required fields.", "danger");
      return;
    }

    const formData = new FormData();
    formData.append("userid", userid);
    formData.append("transection_type", transactionType);
    formData.append("ref_id", refid);

    setLoading(true);
    try {
      const response = await fetch("https://pro.mokshiq.in/paeps_transection_status_check", {
        method: "POST",
        headers: {
          'Authorization': `Bearer ${localStorage.getItem("authToken")}`,
        },
        body: formData,
      });
      const result = await response.json();

      if (result.status) {
        if (result.data?.response_code === 1) {
          showToast(result.data.data.remarks || "Transaction found successfully!", "success");
        } else {
          showToast(result.data.message || "Transaction not found or failed.", "danger");
        }
      } else {
        showToast(result.data || "Status check failed!", "danger");
      }
    } catch (error) {
      console.error(error);
      showToast("Something went wrong while checking status!", "danger");
    } finally {
      setLoading(false);
    }
  };

  return (
    <BaseModal
      show={show}
      onClose={onClose}
      title="DMT Transaction Status Check"
      footerButtons={[
        { label: "Cancel", className: "btn-secondary", dismiss: true },
        {
          label: loading ? "Checking..." : "Check Status",
          className: "btn-primary",
          onClick: handleCheckStatus,
          disabled: loading,
        },
      ]}
    >
      <div className="card-body">
        <form className="row g-3 app-form rounded-control">
          <div className="col-md-12">
            <label className="form-label">Transaction Type</label>
            <select
              id="transaction_type"
              className={`form-control ${errors.transaction_type ? "is-invalid" : ""}`}
              value={transactionType}
              onChange={(e) => setTransactionType(e.target.value)}
            >
              <option value="">Select Transaction Type</option>
              <option value="WALLET_LOAD">WALLET_LOAD</option>
              <option value="TRANSFER">TRANSFER</option>
            </select>
            {errors.transaction_type && <div className="text-danger">{errors.transaction_type}</div>}
          </div>

          <div className="col-md-12">
            <label className="form-label">Reference ID</label>
            <input
              id="refid"
              className={`form-control ${errors.refid ? "is-invalid" : ""}`}
              value={refid}
              onChange={(e) => setRefid(e.target.value)}
              placeholder="Enter Reference ID"
            />
            {errors.refid && <div className="text-danger">{errors.refid}</div>}
          </div>
        </form>
      </div>
    </BaseModal>
  );
}
